import { useWindowSize } from 'lib/utils';
import { useEffect, useState } from 'react';

const HEADER_SIZE = 60;
const HEADER_BORDER_SIZE = 2;
const DESKTOP_MARGIN = 16;
const MOBILE_BREAKPOINT = 600;

export const useChatHeight = () => {
    const windowSize = useWindowSize();
    const [chatHeight, setChatHeight] = useState(0);
    useEffect(() => {
        let newChatHeight = windowSize.height - HEADER_SIZE - HEADER_BORDER_SIZE;
        if (windowSize.width > MOBILE_BREAKPOINT) {
            newChatHeight -= DESKTOP_MARGIN * 2;
        }
        setChatHeight(newChatHeight);
    }, [windowSize]);
    return chatHeight;
};
